'use strict';

import CustomSelect from '../../custom-select/custom-select';
import { initCarousel } from '../../../_scripts/helpers';

export default class ExploreFilmsCarousel {
  constructor($selector, selfInit = true, config) {
    this.$selector = $selector;
    this.breakpoints = config.breakpoints;
    this.$typeSelect = $('select#type', this.$selector);
    this.carouselOptions = {
      centerMode: true,
      centerPadding: '0px',
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      focusOnSelect: true,
      customPaging: (slick, i) => {
        return `<button type="button"><span class="dot-indicator"></span><span class="dot-page">0${
          i + 1
        }</span></button>`;
      },
      responsive: [
        {
          breakpoint: this.breakpoints.tablet,
          settings: {
            centerPadding: '60px',
            slidesToShow: 1,
            slidesToScroll: 1
          },
        }
      ]
    };

    if(selfInit) this.init();
  }

  init() {
    $('.custom-select', this.$selector).map((i, ele) => {
      const selection = new CustomSelect($(ele), true);

      $(ele).find('select').on('change', (e) => {
        const selectVal = $(ele).find('select').val();
        let slideIndex = 0;
        const slideitem = $(`.film-card[data-type="${selectVal}"`, this.$selector);

        for (const item of slideitem) {
          if ($(item).data("slickIndex") >= 0) {
            slideIndex = $(item).data("slickIndex");
            break;
          }
        }
        this.carousel.goToSlide(slideIndex);
      })
    });

    let $carouselElem = $('[data-carousel]', this.$selector);

    let initSlick = (e, slick, currentSlide) => {
      let type = $(`[data-slick-index=${0}]`, $carouselElem).data("type");

      let $latestFilm = $(`.latest-films[data-toggle-type=${type}]`, this.$selector);
      $latestFilm.show();
      $('.explore-films-carousel__latest-films', this.$selector).fadeIn();

      const cur = $(slick.$slides[slick.currentSlide]),
        next = cur.next(),
        next2 = cur.next().next(),
        prev = cur.prev(),
        prev2 = cur.prev().prev();

      prev.addClass('slick-sprev');
      prev2.addClass('slick-sprev2');
      next.addClass('slick-snext');
      next2.addClass('slick-snext2');

      slick.$prev = prev;
      slick.$next = next;
    };

    let beforeChange = (e, slick, currentSlide, nextSlide) => {
      //Configure display for center mode
      const cur = $(slick.$slides[nextSlide]);
      slick.$prev.removeClass('slick-sprev');
      slick.$next.removeClass('slick-snext');
      slick.$prev.prev().removeClass('slick-sprev2');
      slick.$next.next().removeClass('slick-snext2');

      const next = cur.next(),
        prev = cur.prev();

      prev.addClass('slick-sprev');
      next.addClass('slick-snext');
      prev.prev().addClass('slick-sprev2');
      next.next().addClass('slick-snext2');
      slick.$prev = prev;
      slick.$next = next;
      cur.removeClass('slick-next').removeClass('slick-sprev').removeClass('slick-next2').removeClass('slick-sprev2');
      
      //Setup display for latest films
      let type = $(`[data-slick-index=${nextSlide}]`, $carouselElem).data("type");
      let $latestFilm = $(`.latest-films[data-toggle-type=${type}]`, this.$selector);
      
      $('.explore-films-carousel__latest-films', this.$selector).fadeOut(() => {
        // This callback function is executed after the fadeOut animation completes
        $('.latest-films', this.$selector).not($latestFilm).hide();
        // Fade in the new item
        $latestFilm.show();
        $('.explore-films-carousel__latest-films', this.$selector).fadeIn();
      });

      //Update display for 'Explore ...' dropdown
      this.$typeSelect.val(type);
      this.$typeSelect.trigger('change.customSelect');
    }

    this.carousel = initCarousel($carouselElem, this.carouselOptions, true, initSlick, beforeChange);
  }
}
